<script>
  import { page } from '@inertiajs/svelte';
  import { resetHero } from '@/js/utils/stores.js';
  import { onMount } from 'svelte';

  export let data;

  $: socials = data.socials;

  function footerSocials() {
    for (let index = 0; index < socials.length; index++) {
      const item = socials[index];

      item.target = '_blank';

      if (['email', 'telephone'].includes(item.type)) {
        item.target = '_self';
      }

      socials[index] = item;
    }
  }

  function scrollTop() {
    resetHero.set(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onMount(() => {
    footerSocials();
  });
</script>

<div class="footer-main">
  <div class="container">
    <div class="footer-main__inner">
      <div class="footer-main__left">
        <p class="footer-main__title">{@html data.title}</p>
        {#if data.desc}
          <p class="footer-main__desc">{data.desc}</p>
        {/if}
        {#if data.contact_us}
          <div class="footer-main__more">
            <a
              class="btn btn-icon btn-main btn-main--light"
              href={data.contact_us.url}
            >
              <span>{data.contact_us.title}</span>
              <i class="isax isax-arrow-right-1" />
            </a>
          </div>
        {/if}
      </div>

      <div class="line line-horizontal" />

      <div class="footer-main__right">
        <button class="footer-main__top" on:click={scrollTop}>
          <i class="isax isax-arrow-up-2" />
        </button>
        <ul class="footer-main__right-nav">
          {#each socials as item}
            {#if item.label}
              <li class="footer-main__right-item">
                <a
                  class="footer-main__right-nav-item"
                  href={item.url}
                  target={item.target}
                  rel="noreferrer"
                >
                  <img src={item.icon} width="16" height="16" alt={item.type} />
                  <span>{item.label}</span>
                </a>
              </li>
            {/if}
          {/each}
        </ul>
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .footer-main {
    @include resp-max('m') {
      text-align: center;
      padding: 5rem 0;
    }
    @include resp-min('m') {
      padding: 10rem 0;
    }

    .line {
      @include resp-min('m') {
        display: none;
      }
    }

    &__inner {
      @include resp-min('m') {
        display: flex;
      }

      .line {
        @include resp-min('s') {
          margin: 0 -13%;
        }
      }
    }

    &__left {
      @include resp-max('m') {
        padding: 0 0 3rem;
      }
      @include resp-min('m') {
        max-width: 43rem;
      }
    }

    &__title {
      @include resp-max('m') {
        @include h2;
      }

      @include resp-min('m') {
        @include h1;
      }
    }

    &__right {
      @include resp-max('s') {
        padding: 1.5rem 0 0;
        align-items: center;
      }
      @include resp-range('s', 'm') {
        padding: 2.5rem 0 0;
      }

      display: flex;
      flex-direction: column;
      margin-left: auto;

      &-nav {
        @include resp-max('m') {
          display: flex;
          flex-wrap: wrap;
        }

        @include resp-max('xs') {
          display: block;
        }

        margin: auto 0 0;

        &-item {
          display: flex;
          gap: 1.5rem;
          align-items: center;
        }
      }

      &-item {
        @include resp-max('m') {
          width: 50%;
        }

        @include resp-max('xs') {
          width: 100%;
        }

        margin-top: 1.5rem;

        transition: all 0.2s;

        &:hover {
          @include gradient('blue', 135deg);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
    }

    &__title {
    }

    &__desc {
      @include resp-max('m') {
        margin: 2rem auto 0;
      }

      max-width: 40rem;
      margin: 3rem 0 0;
    }

    &__more {
      @include resp-max('m') {
        margin: 2rem 0 0;
      }
      @include resp-min('m') {
        margin: 3rem 0 0;
      }
    }

    &__top {
      @include resp-max('m') {
        display: none;
      }

      display: flex;
      align-items: center;
      justify-content: center;

      width: 5rem;
      height: 5rem;

      border-radius: 50%;
      border: 1px solid var(--aqua-1);

      transition: all 0.25s;

      .isax {
        color: rgb(var(--white));
      }

      &:hover {
        background-color: var(--aqua-1);
      }
    }
  }
</style>
